import styled from 'styled-components';
import { rem } from 'polished';

interface IStyedArticleMeta {
  center: boolean;
  authorBig: boolean;
}

export const StyledArticleMeta = styled.div<IStyedArticleMeta>`
  position: relative;
  display: flex;
  align-items: ${({ center }) => (center ? `center` : `flex-start`)};
  justify-content: space-between;
  margin-bottom: ${rem(`8px`)};

  & .author {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1 0 auto;
    margin-right: ${rem(`4px`)};
    &__name {
      display: -webkit-box;
      width: 100%;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin-left: ${({ authorBig }) => (authorBig ? rem(`24px`) : rem(`6px`))};
      font-size: ${({ authorBig }) => (authorBig ? rem(`24px`) : rem(`16px`))};
    }
  }

  & .tags {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    .tag {
      flex: 0 1 auto;
      span {
        display: -webkit-box;
        width: 100%;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        line-break: anywhere;
      }
    }

    .tag:first-child {
      margin-left: ${rem(`54px`)};
    }
    .tag:not(:last-child) {
      margin-right: ${rem(`4px`)};
    }
  }

  & .meta {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    flex: 0 1 auto;
    &__text {
      text-align: end;
      line-height: ${rem(`36px`)};
      padding-bottom: ${rem(`18px`)};
    }
  }

  .read-time {
    display: flex;
    align-items: center;
    &__content {
      display: -webkit-box;
      width: 100%;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      line-break: anywhere;
    }
    &__icon {
      margin-right: ${rem(`4px`)};
    }
  }
`;
